<template>
  <!-- <div class="player" v-bind:class="{'show': display}" v-scroll="scrollPage"> -->
    <div class="player" v-bind:class="{'show': display}">
    <div class="container">
      <i class="icon-close-1 player-close" @click="playerClose"></i>
      <!-- 图片区域 -->
      <div class="image-area">
        <div class="image-swiper" ref="imageBox" id="imageBox" v-scroll="zoom">
          <!-- <viewer :options="viewerOptions" :images="images"
            @inited="inited" class="viewer" ref="viewer">
            <img v-for="image in images" :src="image.middle" :key="image.id">
          </viewer> -->
          <swiper :options="swiperOption" ref="mySwiper" @transitionEnd="imageTransitionEnd">
            <swiper-slide v-for="image in images" :key="image.id">
              <div class="image-wrapper">
                <img v-bind:src="image.middle" class="swiper-image" :class="{'static': image.animated == false}" alt="" v-bind:style="{ transform: 'rotate(' + image.rotateDeg + 'deg) ' + 'scale(' + image.imageScale + ')'}">
              </div>
            </swiper-slide>
          </swiper>
          <!-- OCR结果显示区域 -->
          <div class="ocr-container" :class="{'show': ocrProcess}">
            <div class="wrapper">
              <i class="icon-close-1" @click="closeOCRPannel"></i>
              <div class="ocr-content">
                <div class="ocr-option">
                  <i class="icon-lang"></i>
                  <span class="ocr-language" :class="{'active': showLanguage, 'en': lang === 'en'}" @mouseover="toggleOcrLanguage(true)" @mouseout="toggleOcrLanguage(false)">
                    <span class="language-text">{{processingOcr.language}}</span>
                    <i class="icon-down-arrow"></i>
                    <div class="language-list">
                      <span class="item" :class="{'active': imageObj.ocrLanguageKey == language.key}" v-for="(language, index) in languageList" :key="index" @click="imageOcrSwitch(language)">{{language.language}}</span>
                    </div>
                  </span>
                </div>
                <div class="ocr-result-text" @mouseover="overOCRContent(true)" @mouseout="overOCRContent(false)">
                  {{imageObj.ocrContent}}
                </div>
                <processing :ocrLoading="ocrLoading"></processing>
              </div>
              <div class="copy-btn">
                <i class="icon-copy" @click="copyOcrContent"></i>
              </div>
            </div>
          </div>
        </div>
        <!-- 左右导航区域 -->
        <div class="swiper-nav left">
          <div class="nav-container" :class="{'grey': index <= 0}" @click="navImage(-1)">
            <i class="icon-prev"></i>
          </div>
        </div>
        <div class="swiper-nav right">
          <div class="nav-container" :class="{'grey': index >= images.length - 1}" @click="navImage(1)">
            <i class="icon-next"></i>
          </div>
        </div>
      </div>
      <!-- 工具栏区域 -->
      <div class="player-toolbar">
        <div class="toolbar-container">
          <!-- 处理方式切换 -->
          <div class="toolbar-item" :class="{'show': hoverPageMode, 'ru_RU': lang === 'ru_RU'}" @mouseenter="pageModeOptions(true)" @mouseleave="pageModeOptions(false)">
            <span class="tool" :class="{'icon-flat': imageObj.userSelectMode == 1,'icon-curve':imageObj.userSelectMode == 2}"></span>
            <span class="arrow icon-up-arrow"></span>
            <div class="tool-gropdown page-mode">
              <span class="option" :class="{'active': imageObj.userSelectMode == 1}" @click="pageModeSwitch(1)">{{$t('player.flatSinglePage')}}<i class="icon-select"></i></span>
              <span class="option" :class="{'active': imageObj.userSelectMode == 2}" @click="pageModeSwitch(2)">{{$t('player.curvePage')}}<i class="icon-select"></i></span>
            </div>
          </div>
          <!-- 色彩模式切换 -->
          <div class="toolbar-item" :class="{'show': hoverColorMode, 'en': lang === 'en', 'ru_RU': lang === 'ru_RU'}"  @mouseenter="colorModeOptions(true)" @mouseleave="colorModeOptions(false)">
            <span class="tool icon-color-mode"></span>
            <span class="arrow icon-up-arrow"></span>
            <div class="tool-gropdown color-mode">
              <span class="option" :class="{'active': imageObj.colorMode == 1}" @click="colorModeSwitch(1)">{{$t('player.color')}}<i class="icon-select"></i></span>
              <span class="option" :class="{'active': imageObj.colorMode == 2}" @click="colorModeSwitch(2)">{{$t('player.grayscale')}}<i class="icon-select"></i></span>
              <span class="option" :class="{'active': imageObj.colorMode == 3}" @click="colorModeSwitch(3)">{{$t('player.bw')}}<i class="icon-select"></i></span>
              <span class="option" :class="{'active': imageObj.colorMode == 4}" @click="colorModeSwitch(4)">{{$t('player.pattern')}}<i class="icon-select"></i></span>
              <span class="option" :class="{'active': imageObj.colorMode == 5}" @click="colorModeSwitch(5)">{{$t('player.autoEnhance')}}<i class="icon-select"></i></span>
            </div>
          </div>
          <!-- 信息 -->
          <!-- <div class="toolbar-item">
            <span class="tool icon-message"></span>
          </div> -->
          <!-- 左旋转 -->
          <div class="toolbar-item" @click="rotateImage(-1)">
            <span class="tool icon-turn-left"></span>
          </div>
          <!-- 右旋转 -->
          <div class="toolbar-item" @click="rotateImage(1)">
            <span class="tool icon-turn-right"></span>
          </div>
          <!-- 下载 -->
          <div class="toolbar-item" @click="downloadImage">
            <span class="tool icon-download-1"></span>
          </div>
          <!-- 分享 -->
          <div class="toolbar-item" @click="openShareBox">
            <span class="tool icon-share-1"></span>
          </div>
          <!-- OCR -->
          <div class="toolbar-item" @click="imageOCRProcess">
            <span class="tool icon-ocr"></span>
          </div>
        </div>
      </div>
      <processing :processing="processing"></processing>
    </div>
    <!-- 图片分享Box -->
    <share-box v-if="showShareBox" :images="shareImages" v-on:toCloseShareBox="closeShareBox"></share-box>
  </div>
</template>
<script>
// import 'viewerjs/dist/viewer.css'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import viewer from 'v-viewer/src/component.vue'
import processing from './Processing'
import * as Config from 'common/script/config'
import HttpClient from 'common/script/http'
import ShareBox from './ShareBox'
class OCRLanguage {
  key = ''
  language = ''
}

export default {
  name: 'player',
  props: {
    images: Array,
    show: Boolean,
    allIndex: Number
  },
  components: {
    swiper,
    swiperSlide,
    processing,
    ShareBox
  },
  data () {
    return {
      index: 0,
      showShareBox: false,
      ocrProcess: false,
      ocrLoading: true,
      showLanguage: false,
      swiperOption: {
        loop: false,
        simulateTouch: false,
        preloadImages: false,
        on: {
        }
      },
      processing: false,
      hoverPageMode: false,
      hoverColorMode: false,
      reloadData: false,
      imageStatic: false,
      playerTransition: false,
      viewerOptions: {
        'inline': true,
        'backdrop': false,
        'container': 'imageBox',
        'minWidth': 800,
        'minHeight': 800,
        'button': false,
        'navbar': false,
        'title': false,
        'toolbar': false,
        'tooltip': true,
        'movable': false,
        'zoomable': true,
        'rotatable': true,
        'scalable': true,
        'transition': true,
        'fullscreen': true,
        'keyboard': true,
        maxZoomRatio: 4,
        'ready': this.viewerReady
      },
      languageList: [],
      pendingOcrKey: '',
      rotateTimer: null,
      ocrTimer: null,
      hoverOCRContent: false,
      lang: ''
    }
  },
  created () {
    if (this.$i18n.locale === 'en') {
      this.lang = 'en'
    }
    if (this.$i18n.locale === 'ru_RU') {
      this.lang = 'ru_RU'
    }
    this.getOCRLanguageList()
  },
  mounted () {
    // console.log(this.$refs.imageBox.clientHeight)
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    },
    display () {
      return this.show
    },
    imageObj () {
      if (this.images.length > 0) {
        return this.images[this.index]
      } else {
        return {}
      }
    },
    shareImages () {
      return [this.imageObj]
    },
    processingOcr () {
      var language = {key: '', language: ''}
      if (this.languageList.length > 0) {
        language = this.languageList[0]
      }
      for (var i = 0; i < this.languageList.length; i++) {
        if (this.languageList[i].key === this.imageObj.ocrLanguageKey) {
          language = this.languageList[i]
          break
        }
      }
      return language
    }
  },
  watch: {
  },
  methods: {
    scrollPage: function (event) {
      if (this.hoverOCRContent) return
      event = event || window.event
      if (event.preventDefault) {
        // Firefox
        event.preventDefault()
        event.stopImmediatePropagation()
        event.stopPropagation()
      } else {
        // IE
        event.cancelBubble = true
        event.returnValue = false
      }
    },
    toggleBodyClass: function (addRemoveClass, className) {
      const el = document.body

      if (addRemoveClass === 'addClass') {
        el.classList.add(className)
      } else {
        el.classList.remove(className)
      }
    },
    inited: function (viewer) {
      this.$viewer = viewer
    },
    viewerReady: function () {
      this.$viewer.view(this.index)
    },
    playerClose: function () {
      this.resetImageConfig(this.index)
      this.toggleBodyClass('remove', 'player-show')
      this.$emit('closeButtonClick')
    },
    cancelReload: function () {
      this.reloadData = false
    },
    showImage: function (index) {
      this.index = index
      // this.toggleBodyClass('addClass', 'player-show')
      // this.viewerOptions.minWidth = 800
      // this.viewerOptions.minHeight = 600
      // this.$viewer.view(this.index)
      this.reloadData = false
      this.swiper.slideTo(this.index, 0, false)
    },
    navImage: function (offset) {
      this.ocrProcess = false
      if (this.reloadData || this.playerTransition) { return }
      var index = this.index
      index += offset
      if (index < 0) {
        index = 0
      }
      if (index >= this.images.length) {
        index = this.images.length - 1
      }
      if (index !== this.index) {
        this.index = index
        this.playerTransition = true
        this.swiper.slideTo(this.index, 600, false)
        // this.$viewer.view(this.index)
      }
    },
    imageTransitionEnd: function () {
      if (this.swiper.previousIndex !== undefined) {
        this.resetImageConfig(this.swiper.previousIndex)
      }
      this.playerTransition = false
      if ((this.allIndex !== 0 && this.index === 1) || this.index === this.images.length - 2) {
        this.reloadData = true
        this.$emit('reloadPlayerData', this.index)
        // console.log('reloadPlayerData', this.index)
      }
    },
    resetImageConfig: function (index) {
      if (this.images[index]) {
        this.images[index].rotateDeg = 0
        this.images[index].imageScale = 1
      }
      this.ocrProcess = false
    },
    pageModeSwitch: function (mode) {
      this.imageObj.userSelectMode = mode
      this.hoverPageMode = false
      this.processing = true
      this.imageStatic = true
      HttpClient.getData(Config.APP_HOST + '/v1/file/newflatten/' + this.imageObj.id + '/' + mode + '?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID), this).then((response) => {
        // console.log(response)
        if (response.code === Config.R_CODE.SUCCESS) {
          this.imageObj.loadPageModeResult(response.body)
          this.$emit('pageModeChanged', this.allIndex + this.index, response.body)
          this.processing = false
          this.imageUpdated()
        } else if (response.code === Config.R_CODE.IMG_PRO_ING) {
          // 轮询处理结果
          var thisObj = this
          var inteval = setInterval(function () {
            HttpClient.getData(Config.APP_HOST + '/v1/file/newflatten/result/' + thisObj.imageObj.id + '/' + mode + '?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID)).then((response) => {
              if (response.code === Config.R_CODE.SUCCESS) {
                clearInterval(inteval)
                thisObj.imageObj.loadPageModeResult(response.body)
                thisObj.$emit('pageModeChanged', thisObj.allIndex + thisObj.index, response.body)
                thisObj.processing = false
                thisObj.imageUpdated()
              }
            })
          }, 2000)
        }
      })
    },
    colorModeSwitch: function (colorMode) {
      this.imageObj.colorMode = colorMode
      this.hoverColorMode = false
      this.processing = true
      this.imageStatic = true
      HttpClient.getData(Config.APP_HOST + '/v1/file/color/' + this.imageObj.id + '/' + colorMode + '?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID), this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          this.imageObj.loadPageModeResult(response.body)
          this.imageUpdated()
          this.processing = false
        } else if (response.code === Config.R_CODE.IMG_PRO_ING) {
          // 轮询处理结果
          var thisObj = this
          var inteval = setInterval(function () {
            HttpClient.getData(Config.APP_HOST + '/v1/file/color/result/' + thisObj.imageObj.id + '/' + colorMode + '?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID)).then((response) => {
              // console.log(response)
              if (response.code === Config.R_CODE.SUCCESS) {
                clearInterval(inteval)
                thisObj.imageObj.loadPageModeResult(response.body)
                thisObj.imageUpdated()
                thisObj.processing = false
              }
            })
          }, 2000)
        }
      })
    },
    pageModeOptions: function (flag) {
      this.hoverPageMode = flag
    },
    colorModeOptions: function (flag) {
      this.hoverColorMode = flag
    },
    imageUpdated: function () { // 图片地址更新后，必须强制调用此方法
      // this.$nextTick(function () {
      //   this.$viewer.update()
      //   this.$viewer.view(this.index)
      //   this.$viewer.reset()
      // })
    },
    zoom: function (event) {
      if (this.ocrProcess) return
      event = event || window.event
      if (event.preventDefault) {
        // Firefox
        event.preventDefault()
        event.stopImmediatePropagation()
        event.stopPropagation()
      } else {
        // IE
        event.cancelBubble = true
        event.returnValue = false
      }
      var scale = this.images[this.index].imageScale
      // var type = event.type
      // if (type === 'DOMMouseScroll' || type === 'mousewheel') {
      //   event.delta = (event.wheelDelta) ? event.wheelDelta / 120 : 0 - (event.detail / 3 || 0)
      // }
      scale = scale * Math.pow(1.01, event.wheelDelta)
      if (scale > 0.2 && scale < 4) {
        this.images[this.index].imageScale = scale
      }
    },
    rotateImage: function (deg) {
      this.images[this.index].rotateDeg += deg * 90
      // this.$viewer.rotate(deg * 90)
      // var thisObj = this
      // var index = this.index
      // if (this.rotateTimer !== null) {
      //   clearTimeout(this.rotateTimer)
      // }
      // this.rotateTimer = setTimeout(function () {
      //   thisObj.realRotateImage(index)
      // }, 300)
    },
    realRotateImage: function (index) {
      this.processing = true
      var img = new Image()
      img.src = this.images[index].middle
      // console.log(img.width, img.height)
      this.images[index].animated = false
      HttpClient.postData(Config.APP_HOST + '/v1/file/cut', {
        u_id: Config.cookieGet(Config.COOKIE_KEY.U_ID),
        fileId: this.images[index].id,
        type: 'flatten',
        mode: this.images[index].mode,
        width: img.width,
        height: img.height,
        angle: this.images[this.index].rotateDeg,
        cutX: 0,
        cutY: 0,
        cutWidth: img.width,
        cutHeight: img.height
      }, this).then((response) => {
        // console.log(response)
        this.images[index].loadEditorResult(response.body)
        this.processing = false
        this.images[index].animated = true
      })
    },
    downloadImage: function () {
      window.location.href = this.images[this.index].big
    },
    openShareBox: function () {
      this.showShareBox = true
    },
    closeShareBox: function () {
      this.showShareBox = false
    },
    getOCRLanguageList: function () {
      HttpClient.getData(Config.APP_HOST + '/v1/file/ocr/language?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID) + '&locale=' + this.$i18n.locale, this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          this.languageList = []
          for (var i = 0; i < response.body.length; i++) {
            var item = response.body[i]
            var ocrLang = new OCRLanguage()
            ocrLang.key = item.key
            // 国际化时根据条件处理
            if (this.$i18n.locale === 'zh-CN') {
              ocrLang.language = item.nameZH
            } else if (this.$i18n.locale === 'zh-TW') {
              ocrLang.language = item.nameZH_TW
            } else {
              ocrLang.language = item.nameEN
            }
            // ocrLang.language = item.nameZH
            this.languageList.push(ocrLang)
          }
        }
      })
    },
    imageOCRProcess: function () {
      this.ocrProcess = !this.ocrProcess
      if (this.ocrProcess) {
        // console.log('do ocr process')
        this.imageOcrSwitch(this.processingOcr)
      }
    },
    imageOcrSwitch: function (keyObj) {
      this.pendingOcrKey = keyObj
      this.showLanguage = false
      this.ocrLoading = true
      this.imageObj.ocrLanguageKey = keyObj.key
      HttpClient.getData(Config.APP_HOST + '/v1/file/ocr/' + this.imageObj.id +
        '/' + keyObj.key + '/' + this.imageObj.rotateDeg + '?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID), this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          if (response.body.isOcred === 1) {
            this.ocrLoading = false
            this.imageObj.ocrContent = response.body.ocrContent
          } else {
            clearInterval(this.ocrTimer)
            // 轮询处理结果
            var thisObj = this
            this.ocrTimer = setInterval(function () {
              HttpClient.getData(Config.APP_HOST + '/v1/file/ocr/result/' + thisObj.imageObj.id + '?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID)).then((response) => {
                if (response.code === Config.R_CODE.SUCCESS) {
                  if (response.body.isOcred === 1) {
                    clearInterval(thisObj.ocrTimer)
                    thisObj.ocrLoading = false
                    thisObj.imageObj.ocrLanguageKey = response.body.ocrLanguage
                    thisObj.imageObj.ocrContent = response.body.ocrContent
                  }
                }
              })
            }, 2000)
          }
        }
      })
    },
    closeOCRPannel: function () {
      this.ocrProcess = false
    },
    toggleOcrLanguage: function (flag) {
      this.showLanguage = flag
    },
    scrollContent: function (event) {
    },
    copyOcrContent: function () {
      if (this.imageObj.ocrContent === '') return
      var thisObj = this
      this.$copyText(this.imageObj.ocrContent).then(function (e) {
        thisObj.$toasted.show(thisObj.$t('player.copyToClipboard'), {
          duration: 2000,
          position: 'bottom-right',
          containerClass: 'ocr-content-body',
          singleton: true
        })
      }, function (e) {
        // console.log(e)
      })
    },
    overOCRContent: function (flag) {
      this.hoverOCRContent = flag
    }
  }
}
</script>
<style lang="stylus" rel="stylesheet/stylus">
_toolbar-height = 204px
.player
  position fixed
  display none
  width 100%
  height 100%
  top 0px
  left 0px
  z-index 999
  &.show
    display block
  .container
    position relative
    display block
    width 100%
    height 100%
    background-color rgba(0,0,0,0.4)
    padding-bottom _toolbar-height - 120px
    box-sizing border-box
    .player-close
      position absolute
      display block
      top 50px
      right 20px
      color #FFFFFF
      font-size 28px
      cursor pointer
      z-index 1002
    .image-area
      position relative
      display flex
      flex-direction column
      justify-content center
      align-items center
      width 100%
      height 100%
      padding 40px 60px 10px
      box-sizing border-box
      .image-swiper
        position relative
        display block
        width 100%
        height 100%
        overflow hidden
        .ocr-container
          position absolute
          display block
          top 0px
          right -240px
          height 100%
          width 240px
          background-color #FFFFFF
          border 1px solid #f5f5f5
          transition all 0.3s ease-in
          z-index 10099
          box-sizing border-box
          &.show
            right 0px
          .wrapper
            position relative
            display block
            width 100%
            height 100%
            padding 56px 22px 66px
            box-sizing border-box
            .icon-close-1
              position absolute
              display block
              top 10px
              right 10px
              font-size 16px
              cursor pointer
            .ocr-content
              position relative
              display block
              width 100%
              height 100%
              padding-top 40px
              box-sizing border-box
              .ocr-option
                position absolute
                display block
                width 100%
                height 24px
                left 0px
                top 0px
                line-height 24px
                text-align left
                .icon-message
                  display inline-block
                  font-size 24px
                  float left
                .ocr-language
                  position relative
                  display inline-block
                  min-width 140px
                  margin-left 4px
                  padding 0px 4px
                  cursor pointer
                  border 1px solid rgba(61, 61, 61, 0)
                  border-bottom none
                  background-color #ffffff
                  &.en
                    width 150px
                    .language-text
                      width 130px
                    .language-list
                      width 152px
                  &.active
                    .language-list
                      height 196px
                      border-radius 4px
                      border 1px solid rgba(0, 0, 0, 0.05)
                      box-shadow: 0px 0px 20px 0px rgba(39, 47, 68, 0.05)
                      overflow-y auto
                  .language-text
                    display inline-block
                    font-size 14px
                    min-width 70px
                  .icon-down-arrow
                    font-size 12px
                  .language-list
                    position absolute
                    top 30px
                    left -1px
                    min-width 140px
                    height 0px
                    overflow hidden
                    box-sizing border-box
                    overflow hidden
                    border 1px solid rgba(61, 61, 61, 0)
                    background-color #ffffff
                    transition height 0.3s ease-in
                    border-radius 4px
                    z-index 999
                    .item
                      display block
                      width 100%
                      height 24px
                      padding 0px 4px
                      line-height 24px
                      font-size 14px
                      box-sizing border-box
                      &:hover
                        background-color #ebebeb
                      &.active
                        background-color #ebebeb
              .ocr-result-text
                position relative
                display block
                width 100%
                height 100%
                font-size 12px
                line-height 16px
                text-align left
                word-break break-word
                overflow-y auto
            .copy-btn
              position absolute
              display flex
              flex-direction row
              justify-content center
              align-items center
              width 100%
              height 60px
              left 0px
              bottom 0px
              font-size 20px
              line-height 60px
              .icon-copy
                display block
                cursor pointer
      .swiper-nav
        position absolute
        display flex
        flex-direction column
        justify-content center
        align-items center
        width 60px
        height 100%
        top 0px
        .nav-container
          display flex
          width 100%
          height 70%
          flex-direction column
          justify-content center
          align-items center
          i
            color #FFFFFF
            font-size 48px
            cursor pointer
          &.grey
            i
              color rgba(255, 255, 255, 0.2)
              cursor default
        &.left
          left 0px
        &.right
          right 0px
    .player-toolbar
      position absolute
      display flex
      width 100%
      height _toolbar-height
      left 0px
      bottom 0px
      padding-bottom 36px
      flex-direction column
      justify-content flex-end
      align-items center
      background-image url('../../assets/images/player_toolbar_bg.png')
      background-repeat repeat-x
      background-position center left
      box-sizing border-box
      .toolbar-container
        display flex
        width 760px
        height 56px
        flex-direction row
        justify-content space-around
        align-items center
        .toolbar-item
          position relative
          display flex
          flex-direction row
          justify-content center
          align-items center
          width 42px
          height 26px
          &.show
            .tool-gropdown
              opacity 1
              &.page-mode
                height 49px
              &.color-mode
                height 111px
            .arrow
              color #fafafa
          &.en
            .tool-gropdown
              width 110px
          &.ru_RU
            .color-mode
              width 128px
            .page-mode
              width 150px
          .tool
            color #a1a1a1
            font-size 30px
            cursor pointer
            &:hover
              color #FFFFFF
          .arrow
            color #a1a1a1
            font-size 12px
          .tool-gropdown
            position absolute
            display flex
            width 80px
            height 0px
            left 30px
            bottom 22px
            flex-direction column
            justify-content flex-start
            align-items flex-start
            background-color rgba(0,0,0,0.8)
            border-radius 4px
            color #939393
            font-size 13px
            z-index 1002
            overflow hidden
            box-sizing border-box
            opacity 0
            transition all 0.3s ease
            padding 4px 0
            .option
              display block
              padding 4px 6px
              box-sizing border-box
              text-align left
              cursor pointer
              &:hover
                color #FFFFFF
              .icon-select
                display none
                padding-left 4px
                font-size 12px
              &.active
                color #FFFFFF
                .icon-select
                  display inline-block
.image-swiper
  .viewer
    width 100%
    height 100%
    img
      display none
  &.image-static
    .viewer-transition
      transition all 0.4s ease
  .viewer-transition
    transition all 0.4s ease
.swiper-container
  display block
  width 100%
  height 100%
  .swiper-wrapper
    .swiper-slide
      display flex
      flex-direction column
      justify-content center
      align-items center
      padding 0 20px
      box-sizing border-box
      .image-wrapper
        display flex
        position relative
        width 100%
        height 100%
        overflow hidden
        flex-direction column
        justify-content center
        align-items center
        overflow hidden
        color #FFFFFF
        .swiper-image
          max-width 100%
          max-height 100%
          transition all 0.2s
          &.static
            transition none
</style>



// WEBPACK FOOTER //
// src/components/Et/Player.vue